module.exports = __webpack_public_path__ + "static/media/app.1ebda33d.svg";